import WarningAmberIcon from '@mui/icons-material/WarningAmber'
import OpenInNewIcon from '@mui/icons-material/OpenInNew'
import { Alert, Button, Skeleton, Stack } from '@mui/material'
import { StatusChip } from '@src/components/StatusChip'
import { DocsAutomation } from '@src/types/automationDocument'
import { memo } from 'react'
import { useTranslation } from 'react-i18next'

interface InformationsProps {
  docsAutomation: DocsAutomation | null
}

const Informations = ({ docsAutomation }: InformationsProps) => {
  const { t } = useTranslation()

  return (
    <Stack>
      {docsAutomation ? (
        <>
          <Stack direction="row" justifyContent="space-between" gap={1} alignItems="center">
            {docsAutomation.email?.webLink ? (
              <Button
                component="a"
                href={docsAutomation.email.webLink}
                target="_blank"
                rel="noopener noreferrer"
                startIcon={<OpenInNewIcon />}
                size="small"
              >
                {t('docsAutomation.viewMessageInOutlook' as const)}
              </Button>
            ) : (
              <span>{`${docsAutomation.originSystem.toUpperCase()} System`}</span>
            )}
            <Stack direction="row" gap={1} alignItems="center">
              <StatusChip status={docsAutomation.processingStatus} />
            </Stack>
          </Stack>
          {docsAutomation.warnings?.length > 0 && (
            <Stack gap={0.5} mt={1}>
              {docsAutomation.warnings.map((warning, index) => (
                <Alert
                  key={index}
                  severity="warning"
                  variant="outlined"
                  icon={<WarningAmberIcon fontSize="small" />}
                  sx={{ py: 0 }}
                >
                  {t(`enum.warningCode.${warning.code}` as never, { fileName: warning.fileName })}
                </Alert>
              ))}
            </Stack>
          )}
        </>
      ) : (
        <Skeleton variant="rectangular" />
      )}
    </Stack>
  )
}

export default memo(Informations)
